 <!-- Preloader Start -->
 <div class="ct-preloader" *ngIf="isLoading">
    <div class="ct-preloader-inner">
        <div class="lds-ripple">
            <div></div>
            <div></div>
        </div>
    </div>
</div>
<!-- Preloader End -->